import type { DialogRenderProps } from "react-aria-components";
import React, { useState } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { Modal2 } from "@/ui2/molecules/Modal";
import { useSendWelcomeEmail } from "@/features/patient/api/mutations/useSendWelcomeEmail";

type Props = {
  email: string;
  patientId: string;
  trigger: React.ReactElement;
};

export function OnDemandWelcomeEmailModal({ email, patientId, trigger }: Props) {
  const [step, setStep] = useState<"confirm" | "success">("confirm");
  const { mutateAsync: sendWelcomeEmail } = useSendWelcomeEmail();

  const handleSend = async () => {
    try {
      await sendWelcomeEmail({ patientId });
      setStep("success");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal2
      className="tw:max-w-66"
      overlayProps={{
        onOpenChange: (isOpen) => {
          if (!isOpen) setStep("confirm");
        },
      }}
      title={step === "confirm" ? "Resend registration email" : "Email sent"}
      trigger={trigger}
    >
      {({ close }: DialogRenderProps) =>
        step === "confirm" ? (
          <div className="tw:flex tw:flex-col tw:gap-4">
            <p className="body-md">
              Resend welcome email to <strong data-private>{email}</strong>?
            </p>

            <div className="tw:flex tw:justify-end tw:gap-2">
              <Button2 className="tw:min-w-25" onPress={close} variant="secondary">
                Cancel
              </Button2>

              <Button2 className="tw:min-w-25" onPress={handleSend} variant="primary">
                Yes
              </Button2>
            </div>
          </div>
        ) : (
          <div className="tw:flex tw:flex-col tw:gap-4">
            <p className="body-md">
              The welcome email has been resent. Please instruct the member to check their inbox and
              complete registration.
            </p>

            <Button2 className="tw:min-w-25 tw:self-end" onPress={close} variant="primary">
              OK
            </Button2>
          </div>
        )
      }
    </Modal2>
  );
}
